import { createFileRoute } from '@tanstack/react-router';

import { HiringQuotePage } from '@/features/hiring/quote-page';

export const Route = createFileRoute('/_app/projects/$projectId/hiring/quotes/$quoteId')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId, quoteId } = Route.useParams();
  return <HiringQuotePage projectId={projectId} quoteId={quoteId} />;
}
